import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["form", "separator", "imageContainer", "videoContainer"];

  connect() {
    this.imageField = this.element.querySelector('[data-dropzone-param-name-value="gallery_item[image]"]')

    this.videoField = this.element.querySelector('[data-dropzone-param-name-value="gallery_item[video_attributes][video_file]"]')

    this.addEventListeners()
  }

  disconnect() {
    this.removeEventListeners()
  }

  addEventListeners() {
    if(!this.imageField || !this.videoField) return

    this.element.addEventListener("dropzone:start", this.hideInputFields.bind(this))
    this.element.addEventListener("dropzone:removedfile", this.showInputFields.bind(this))
    this.element.addEventListener("dropzone:success", this.onSuccess.bind(this))
  }

  removeEventListeners() {
    if(!this.imageField || !this.videoField) return

    this.element.removeEventListener("dropzone:start", this.hideInputFields.bind(this))
    this.element.removeEventListener("dropzone:removedfile", this.showInputFields.bind(this))
    this.element.removeEventListener("dropzone:success", this.onSuccess.bind(this))
  }

  // Other methods ----------------

  hideInputFields(e) {
    const target = e.target

    if (target === this.imageField) {
      // disabled video input
      this.hideVideoInput()
      this.hideSeparator()
    } else if (target === this.videoField) {
      // disable image input
      this.hideImageInput()
      this.hideSeparator()
    }
  }

  showInputFields(e) {
    const target = e.target

    if (target === this.imageField) {
      // enable video input
      this.showVideoInput()
      this.showSeparator()
    } else if (target === this.videoField) {
      // enable image input
      this.showImageInput()
      this.showSeparator()
    }
  }

  onSuccess(e) {
    const target = e.target
    if (target === this.imageField) {
      this.submitForm()
    }
  }

  // Helper methods ----------------

  hideImageInput() {
    if (!this.hasImageContainerTarget) return
    this.imageContainerTarget.style.display = "none"
  }

  hideVideoInput() {
    if (!this.hasVideoContainerTarget) return
    this.videoContainerTarget.style.display = "none"
  }

  hideSeparator() {
    if (!this.hasSeparatorTarget) return
    this.separatorTarget.style.display = "none"
  }

  showImageInput() {
    if (!this.hasImageContainerTarget) return
    this.imageContainerTarget.style.display = "block"
  }

  showVideoInput() {
    if (!this.hasVideoContainerTarget) return
    this.videoContainerTarget.style.display = "block"
  }

  showSeparator() {
    if (!this.hasSeparatorTarget) return
    this.separatorTarget.style.display = "block"
  }

  submitForm() {
    this.formTarget.requestSubmit();
  }
}
